import { TeamListPage } from '@numeo/types-main-web-app'

/** What a directory list hook answers, at either stage. */
export interface TeamListState<T> {
    /** The rows of the page asked for; the previous answer's while a new page or search loads. */
    items: T[]
    /** How many rows the whole query matches, across pages. */
    total: number
    /** No answer yet for anything. */
    isLoading: boolean
    /** A request is in flight (a new page, a search, a refetch). */
    isFetching: boolean
    /** The last request failed; `items` keeps the last answer. */
    isError: boolean
}

const NO_ROWS: never[] = []

export const listStateOf = <T>(page: TeamListPage<T> | undefined, flags: { isLoading: boolean; isFetching: boolean; isError: boolean }): TeamListState<T> => ({
    items: page?.items ?? NO_ROWS,
    total: page?.pagination.total ?? 0,
    ...flags,
})

export const READY = { isLoading: false, isFetching: false, isError: false }
